<template>
  <v-list-item class="pl-0">
    <v-list-item-avatar class="my-2">
      <v-badge v-if="avatarBadgeNr"
               bottom
               overlap>
        <template #badge>
          <span>{{ avatarBadgeNr }}</span>
        </template>
        <fin-avatar :avatar-size="avatarIconSize"
                    :item="{ img: content.user.avatar}"
                    disable-tooltip/>
      </v-badge>

      <fin-avatar v-else
                  :avatar-size="avatarIconSize"
                  :item="{ img: content.user.avatar}"
                  disable-tooltip/>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title class="top-line mb-1">
        {{ content.user.name.toUpperCase() }}
        <span v-if="!hideTimeAgo"> &#8211; </span>
        <fin-time-ago :datetime="content.lastModified" class="d-inline ml-1 mr-3"/>
        <span v-if="!hideCategory" class="type">{{ content.category }}</span>
      </v-list-item-title>
      <v-list-item-subtitle>
        <h6>{{ subtitle }}</h6>
        <div v-if="$slots.customContent" style="float: right;">
          <!-- @slot slot for displaying custom content right aligned at the subtitle line -->
          <slot name="customContent"/>
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import FinAvatar from "@/components/common/avatar"

export default {
  name: "fin-community-content",
  components: {FinAvatar},
  props: {
    /** An object containing the user with avatar url + name, lastModified, category */
    content: {
      type: Object,
      default: null
    },
    /** The subtitle beneath the user info + category */
    subtitle: {
      type: String
    },
    /** Hide the time the content was created */
    hideTimeAgo: {
      type: Boolean,
      default: false
    },
    /** Hide the category of the content */
    hideCategory: {
      type: Boolean,
      default: false
    },
    /** The size of the avatar image */
    avatarIconSize: {
      type: Number,
      default: 40
    },
    /** The number the badge should display */
    avatarBadgeNr: {
      type: Number,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.top-line {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-cool-grey;
}

.type {
  border: 1px solid $fin-color-light-blue-gray;
  padding: 2px 5px;
  background-color: $fin-color-pale-grey;
  color: $fin-color-primary-dark;
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  /* additional */
  display: inline-block;
}

h6 {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  float: left;
}

.v-list-item__content {
  padding-top: 16px;
  padding-bottom: 0;
  height: max-content;
}

.v-avatar {
  overflow: visible;
}
</style>
